
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockStyleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlockStyle"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"background"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetFields"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"spacing"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marginBottom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marginLeft"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marginRight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marginTop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paddingBottom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paddingLeft"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paddingRight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paddingTop"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fontsAndColors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textColor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"borders"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyBorder"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"applyBoxShadow"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"alignmentAndOrientation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flipOrientation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alignment"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"customCss"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cssClassName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customCssRules"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"KeyValueFields"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":592}};
    doc.loc.source = {"body":"#import \"./AssetFields.graphql\"\n#import \"./KeyValueFields.graphql\"\n\nfragment BlockStyleFields on BlockStyle {\n  width\n  background {\n    backgroundColor\n    backgroundImage {\n      ...AssetFields\n    }\n  }\n  spacing {\n    marginBottom\n    marginLeft\n    marginRight\n    marginTop\n    paddingBottom\n    paddingLeft\n    paddingRight\n    paddingTop\n  }\n  fontsAndColors {\n    textColor\n  }\n  borders {\n    applyBorder\n    applyBoxShadow\n  }\n  alignmentAndOrientation {\n    flipOrientation\n    alignment\n  }\n  customCss {\n    cssClassName\n    customCssRules {\n      ...KeyValueFields\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./AssetFields.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./KeyValueFields.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["BlockStyleFields"] = oneQuery(doc, "BlockStyleFields");
        
